import { Component, OnInit, Input } from '@angular/core';
import {
  Validators,
  FormGroup,
  FormControl,
  ReactiveFormsModule,
} from '@angular/forms';
import { EthnicService } from 'src/app/services/ethnic/ethnic.service';
import { DropdownService } from 'src/app/services/dropdown/dropdown.service';
import { Router, RouterModule } from '@angular/router';
import { CommonModule } from '@angular/common';
import { NumberFormatDirective } from 'src/app/directives/number-format.directive';
import { NumberFormatPipe } from 'src/app/pipes/number-format.pipe';
import { NumberFormatter } from 'src/app/tools/number-formatter';
import { max10DigitsValidator } from 'src/app/validators/max-digits.validator';

@Component({
  selector: 'app-add-ethnic-group',
  templateUrl: './add-ethnic-group.component.html',
  styleUrls: ['./add-ethnic-group.component.css'],
  standalone: true,
  imports: [CommonModule, RouterModule, ReactiveFormsModule, NumberFormatDirective],
})
export class AddEthnicGroupComponent implements OnInit {
  numberPattern: string = '^[0-9]+$';
  decimalPattern: string = '^[0-9]+(\.[0-9]{1,2})?$'; // Positive decimals only
  ethnicGroupForm!: FormGroup;
  mainError: any;
  @Input() editItem!: string;
  submitted: boolean = false;
  addState = true; //this is set to true or else ng serve gets stuck
  id: any;
  status!: string;
  instructions!: string;
  constructor(
    private ethnicService: EthnicService,
    private dropdownService: DropdownService,
    private router: Router,
  ) { }

  ngOnInit() {
    if (this.router.url == '/current-ethnic-groups') {
      this.status = 'Current';
      //      this.instructions = 'Please add each of the ethnic groups your ministry is currently working among and the progress of the work. When the information of your ministry current ethnic group work has been entered, please click save and continue at the bottom.';
      this.instructions =
        'Please tell us what Ethnic Groups you have ministry among, and where you are doing this.  This includes the number of workers, believers, and Churches, and when you started the particular work.  If you have given us information before, it is already listed below.  Please add to this list by selecting “Add Ethnic Group”, or edit the existing information by selecting “Edit” on the line you want to edit.';
    } else {
      this.status = 'Future';
      //      this.instructions = 'Please add any additional ethnic groups that your ministry is planning to work among in the future. This should include the number of workers you are planning to send, and the monthly cost. When all information of your ministry planned future ethnic group work has been entered, please click save and continue at the bottom.';
      this.instructions =
        'Please tell us if you plan to start any new ministry among certain Ethnic Groups in the future.  This includes the number of workers you want to put to that ministry, and how much it will cost per worker. If you have given us information before, it is already listed below.  Please add to this list by selecting “Add Ethnic Group”, or edit the existing information by selecting “Edit” on the line you want to edit. If you have actually started any of the work listed, select “Make Current”, and this information will be moved to the previous page.';
    }
    this.ethnicGroupForm = new FormGroup({
      Name: new FormControl(null, [Validators.required]),
      //Language: new FormControl(null, [Validators.required]),
      //Location: new FormControl(null, [Validators.required]),
      Language: new FormControl(null),
      Location: new FormControl(null),
      Action: new FormControl('A', [Validators.required]),
      Status: new FormControl(null, [Validators.required]),
      Workers: new FormControl(null, [
        Validators.required,
        Validators.pattern(this.numberPattern),
        max10DigitsValidator(),
      ]),
      WorkersBenefitted: new FormControl(null, [
        Validators.required,
        Validators.pattern(this.numberPattern),
        max10DigitsValidator(),
      ]),
      Churches: new FormControl(null, [
        Validators.required,
        Validators.pattern(this.numberPattern),
        max10DigitsValidator(),
      ]),
      Believers: new FormControl(null, [
        Validators.required,
        Validators.pattern(this.numberPattern),
        max10DigitsValidator(),
      ]),
      AmountPerWorker: new FormControl(null, [
        Validators.required,
        Validators.pattern(this.decimalPattern),
        max10DigitsValidator(),
      ]),
      Year: new FormControl(null, [
        Validators.required,
        Validators.pattern(this.numberPattern),
        max10DigitsValidator(),
      ]),
    });
  }

  onSubmit() {
    if (this.router.url == '/current-ethnic-groups') {
      this.submitted = true;
      this.ethnicGroupForm.patchValue({
        Action: 'A',
        Status: 'C',
        AmountPerWorker: 0,
      });
      console.log(this.ethnicGroupForm.value);
      console.log(this.ethnicGroupForm.value);
      if (!this.ethnicGroupForm.valid) {
        return;
      }
      console.log(this.router.url);

      // Clean the form data to ensure raw numbers are sent to API
      const cleanedData = this.cleanFormData(this.ethnicGroupForm.value);
      this.ethnicService
        .addEthnicGroup(cleanedData, 'Current')
        .subscribe(() => {
          // Refresh completion status from API
          this.dropdownService.setPageCompletionStatuses();
        });
      this.addState = !this.addState;
      this.submitted = false;
      this.ethnicGroupForm.reset();
    } else {
      this.submitted = true;
      this.ethnicGroupForm.patchValue({
        Action: 'A',
        Status: 'F',
        WorkersBenefitted: 0,
        Churches: 0,
        Believers: 0,
      });
      console.log(this.ethnicGroupForm.value);
      if (!this.ethnicGroupForm.valid) {
        return;
      }
      console.log(this.router.url);

      // Clean the form data to ensure raw numbers are sent to API
      const cleanedData = this.cleanFormData(this.ethnicGroupForm.value);
      this.ethnicService
        .addEthnicGroup(cleanedData, 'Future')
        .subscribe(() => {
          // Refresh completion status from API
          this.dropdownService.setPageCompletionStatuses();
        });
      this.addState = !this.addState;
      this.submitted = false;
      this.ethnicGroupForm.reset();
    }
  }

  private cleanFormData(formData: any): any {
    const cleanedData = { ...formData };

    // Clean numeric fields to ensure raw numbers are sent to API
    const numericFields = ['Workers', 'WorkersBenefitted', 'Churches', 'Believers', 'AmountPerWorker', 'Year'];

    numericFields.forEach(field => {
      if (cleanedData[field] !== null && cleanedData[field] !== undefined) {
        const rawValue = NumberFormatter.getRawNumber(cleanedData[field]);
        cleanedData[field] = rawValue !== null ? rawValue : cleanedData[field];
      }
    });

    return cleanedData;
  }
  change() {
    this.addState = !this.addState;
  }

  changeChoice(e: any) {
    console.log(e);
    this.ethnicGroupForm.controls['Status'].setValue(e.target.value, {
      onlySelf: true,
    });
  }
}
